export enum HomeDialogEventName {
  BREAKING_SOUND_ELEGIBLE = "BREAKING_SOUND_ELEGIBLE",
  BREAKING_SOUND_INELEGIBLE = "BREAKING_SOUND_INELEGIBLE",
}
